import { dmnStorage } from "../dmnStorage";

export type PreviewModalConfigDataStorageType = {
  separateByType: boolean;
  separateBySubtype: boolean;
  separateFixedPriceMenuItems: boolean;
  separateByTime: boolean;
  displayForNames: boolean;
};

export const previewModalConfigStorageDefault: PreviewModalConfigDataStorageType =
  {
    separateByType: false,
    separateBySubtype: false,
    separateFixedPriceMenuItems: false,
    separateByTime: false,
    displayForNames: false
  };

export const getPreviewModalConfigFromStorage =
  async (): Promise<PreviewModalConfigDataStorageType> => {
    const previewModalConfig = await dmnStorage.get("previewModalConfigBeta");
    return previewModalConfig ?? previewModalConfigStorageDefault;
  };

export const setPreviewModalConfigToStorage = async (
  previewModalConfig: PreviewModalConfigDataStorageType
): Promise<void> => {
  await dmnStorage.add("previewModalConfigBeta", previewModalConfig);
};
